module.exports = __webpack_public_path__ + "static/media/close.4703fea0.svg";